import React from "react";

import './GameMatchUpInfo.style.scss';

const GameMatchUpInfo = ({playerTeamId, awayTeamId, awayTeamKey, homeTeamId, homeTeamKey}) => {

    return <React.Fragment>
        <span className={`${playerTeamId === awayTeamId ? 'playerTeam' : ''}`}>{awayTeamKey} </span>
        @
        <span className={`${playerTeamId === homeTeamId ? 'playerTeam' : ''}`}> {homeTeamKey}</span>
    </React.Fragment>
}

export default GameMatchUpInfo;